import { getInitialHistory } from "../../utils/core/historyUtils";

export const createInputHistorySlice = (set, get) => ({
  // Input and history state
  input: "",
  history: getInitialHistory(),
  historyIndex: null,
  suggestionText: "",

  // Input and history setters
  setInput: (input) => set({ input }),
  setHistory: (history) => set({ history }),
  setHistoryIndex: (index) => set({ historyIndex: index }),
  setSuggestionText: (text) => {
    set({ suggestionText: text });
    // Auto-scroll when suggestion text is updated with longer delay to ensure DOM is updated
    if (text) {
      // Get the scroll function from the store
      const store = get();
      if (store.scrollToBottomByFocus) {
        store.scrollToBottomByFocus();
      }
    }
  },
});
